import { render, staticRenderFns } from "./MaterialsModal.html?vue&type=template&id=7dcb637e&scoped=true&external"
import script from "./MaterialsModal.ts?vue&type=script&lang=ts&external"
export * from "./MaterialsModal.ts?vue&type=script&lang=ts&external"
import style0 from "./MaterialsModal.css?vue&type=style&index=0&id=7dcb637e&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dcb637e",
  null
  
)

export default component.exports